import { render, staticRenderFns } from "./log3.vue?vue&type=template&id=60ddb213&scoped=true"
import script from "./log3.vue?vue&type=script&lang=js"
export * from "./log3.vue?vue&type=script&lang=js"
import style0 from "./log3.vue?vue&type=style&index=0&id=60ddb213&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ddb213",
  null
  
)

export default component.exports